@if (loader && !disableLoader) {
<div class="spinner-container">
    <mat-spinner class="mat-spinner"></mat-spinner>
</div>
}

<mat-toolbar class="header-container">
    <div class="logo-container">
      <img src="assets/common/dealer-logo.png" alt="Dealer Logo" class="dealer-logo-icon" />
    </div>
    <span class="example-spacer"></span>
    @if (headerReady && showIconContainer) {
    <div class="header-icons-container">
        @if (showHomeIcon) {
        <div class="home-icon-div" (click)="onHomeIconClick()">
            <mat-icon aria-hidden="false" aria-label="Example home icon" fontIcon="location_on"
                class="location-icon"></mat-icon>
        </div>
        }
        @if (!router.url.includes('locations') || isDealerComponentReady) {
        <div class="translate-icon">
            @if (translateIconLoaded) {
            <mat-icon #language mat-button [matMenuTriggerFor]="menu" class="translate-icon-button"
                fontIcon="translate">
            </mat-icon>

            <span class="language-code">{{ currentLanguage || 'EN' }}</span>
            }

            <mat-menu #menu="matMenu" xPosition="before" yPosition="below" panelClass="language-menu">
                @for (i of languageConfiguration.Langauges; track i) {
                <div>
                    <button mat-menu-item (click)="switchLanguage(i.LanguageFileName)">
                        <img src="{{ i.SvgFlagAddress }}" style="border-radius: 50%; width: 30px; height: 30px;"
                            alt="{{ i.SvgFlagAddress }}">
                        {{ i.LanguageToShowInMenu }}
                    </button>
                </div>
                }
            </mat-menu>
        </div>
        }
    </div>
    }
</mat-toolbar>
<router-outlet />